import { z } from 'zod'

import type { FieldErrorsMapper } from '@/hooks/useMutationWithErrorsHandling'
import i18n from '@/i18n'
import { labelAndValue, requiredStringWithLabel } from '@/utils/zod'

export const courseFormPayload = () =>
  z.object({
    educationLevel: requiredStringWithLabel(
      i18n.t('label.education-level', { ns: 'coursesManagement' })
    ),
    name: requiredStringWithLabel(
      i18n.t('label.course-name', { ns: 'coursesManagement' })
    ).max(80, i18n.t('error.max-length', { ns: 'common', NUMBER: 80 })),
    domain: labelAndValue(
      z.string(),
      i18n.t('error.required-field-with-label', {
        ns: 'common',
        LABEL: i18n.t('label.domain', { ns: 'coursesManagement' })
      })
    ),
    preferredRooms: z.array(labelAndValue()).optional()
  })

export type CourseFormPayload = z.infer<ReturnType<typeof courseFormPayload>>

export const fieldErrorsMapper: FieldErrorsMapper<CourseFormPayload> = {
  education_level: 'educationLevel',
  name: 'name',
  domain: 'domain',
  preferred_rooms: 'preferredRooms',
  non_field_error: 'root'
}
